import { baseAxios } from "../Features/Utils/axiosUtil";
import { APP_URLS } from "./apiUrls";
import toast from "react-hot-toast";

// Generate OTP
export const generateOtp = async (data) => {
  try {
    const res = await baseAxios.post(APP_URLS.generateOtp(), data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res?.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

// Validate OTP
export const validateOtp = async (data) => {
  try {
    const res = await baseAxios.post(APP_URLS.validateOtp(), data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res?.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const getUser = async (id) => {
  try {
    const res = await baseAxios.get(APP_URLS.getUser(id));
    return res.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const registerUser = async (data) => {
  try {
    const res = await baseAxios.post(APP_URLS.registerUser(), data);
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const createBooking = async (data) => {
  try {
    const res = await baseAxios.post(APP_URLS.createBooking(), data);
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const getBannerList = async () => {
  try {
    const res = await baseAxios.get(APP_URLS.getBanner());
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const getBannerOfferList = async () => {
  try {
    const res = await baseAxios.get(APP_URLS.getBannerOffer());
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const getCategoryList = async () => {
  try {
    const res = await baseAxios.get(APP_URLS.getCategoryList());
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const getProductVariants = async () => {
  try {
    const res = await baseAxios.get(APP_URLS.getProductVariants());
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const getListProductVariantsMax = async () => {
  try {
    const res = await baseAxios.get(APP_URLS.getListProductVariantsMax());
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const getProductsTypes = async () => {
  try {
    const res = await baseAxios.get(APP_URLS.getProductsTypes());
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const getProductsList = async (dataFilter) => {
  try {
    const params = new URLSearchParams(dataFilter);
    const res = await baseAxios.get(
      `${APP_URLS.getProductsList()}&${params.toString()}`,
    );
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const getSingleProductsList = async (slug) => {
  try {
    const res = await baseAxios.get(APP_URLS.getSingleProductsList(slug));
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const refreshTokenUser = async (data) => {
  try {
    const res = await baseAxios.post(APP_URLS.refreshToken(), data);
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const getAddressList = async (data) => {
  try {
    const res = await baseAxios.post(APP_URLS.getAddressList(), data);
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const addressCreate = async (data) => {
  try {
    const res = await baseAxios.post(APP_URLS.addressCreate(), data);
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const addressUpdate = async (data) => {
  try {
    debugger;
    const res = await baseAxios.post(APP_URLS.addressUpdate(), data);
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const setDefaultAddress = async (data) => {
  try {
    const res = await baseAxios.post(APP_URLS.setDefaultAddress(), data);
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const addressDelete = async (data) => {
  try {
    const res = await baseAxios.post(APP_URLS.addressDelete(), data);
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const addressDeliver = async (userId, addressId) => {
  try {
    const res = await baseAxios.get(
      APP_URLS.setDefaultAddress(userId, addressId),
    );
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const userUpdate = async (userId, data) => {
  try {
    const res = await baseAxios.post(APP_URLS.userUpdate(userId), data);
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const userUploadAvatar = async (formData) => {
  try {
    const res = await baseAxios.post(APP_URLS.userUploadAvatar(), formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const createOrder = async (data) => {
  try {
    const res = await baseAxios.post(APP_URLS.createOrder(), data);
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const getOrderDetails = async (orderId, userId) => {
  try {
    const res = await baseAxios.get(APP_URLS.getOrderDetails(orderId, userId));
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const getUserOrders = async (userId) => {
  try {
    const res = await baseAxios.get(APP_URLS.getUserOrders(userId));
    return res;
  } catch (error) {
    handleApiError(error);
  }
};
export const loadSavedCards = async (userId) => {
  try {
    const res = await baseAxios.get(APP_URLS.loadSavedCards(userId));
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const addressDeliverDefault = async (userId) => {
  try {
    const res = await baseAxios.get(APP_URLS.addressDeliverDefault(userId));
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const getCheckout = async (userId) => {
  try {
    const res = await baseAxios.get(APP_URLS.getCheckout(userId));
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const getPaymentMethods = async (userId) => {
  try {
    const res = await baseAxios.get(APP_URLS.getPaymentMethods());
    return res;
  } catch (error) {
    handleApiError(error);
  }
};

export const generateUPIQR = async (amount, order_id) => {
  try {
    const res = await baseAxios.post(APP_URLS.generateUPIQR(), {
      amount: amount,
      order_id: order_id,
    });

    return res.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const processUPIIntent = async (amount, vpa, order_id) => {
  try {
    const res = await baseAxios.post(APP_URLS.processUPIIntent(), {
      amount,
      vpa,
      order_id: order_id,
    });

    return res.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const verifyPayment = async (transactionId) => {
  try {
    const { data } = await baseAxios.post(APP_URLS.verifyPayment(), {
      transaction_id: transactionId,
    });

    return data;
  } catch (error) {
    handleApiError(error);
  }
};

export const retryPayment = async (transactionId) => {
  try {
    const { data } = await baseAxios.post(APP_URLS.retryPayment(), {
      transaction_id: transactionId,
    });

    return data;
  } catch (error) {
    handleApiError(error);
  }
};

export const processCardPayment = async (cardDetails, order_id) => {
  try {
    const { data } = await baseAxios.post(APP_URLS.processCardPayment(), {
      card_number: cardDetails.cardNumber,
      expiry_month: cardDetails.expiryMonth,
      expiry_year: cardDetails.expiryYear,
      cvv: cardDetails.cvv,
      amount: cardDetails.amount || 20245,
      order_id: order_id || `ORD${Date.now()}`,
    });

    return data;
  } catch (error) {
    handleApiError(error);
  }
};
export const processCOD = async (amount, order_id) => {
  try {
    const { data } = await baseAxios.post(APP_URLS.processCOD(), {
      amount,
      order_id: order_id || `ORD${Date.now()}`,
    });

    return data;
  } catch (error) {
    handleApiError(error);
  }
};

export const applyGiftCard = async (giftCode) => {
  try {
    const { data } = await baseAxios.post(APP_URLS.applyGiftCard(), {
      gift_code: giftCode,
    });

    return data;
  } catch (error) {
    handleApiError(error);
  }
};

export const toastSuccess = (message = "Success!") => {
  return toast.success(message, {
    duration: 2000,
    style: {
      background: "radial-gradient(circle at top, #1F7A3E, #C8A97E, #3FAF6B)",
      color: "#fff",
    },
    iconTheme: {
      primary: "#fff",
      secondary: "#3FAF6B",
    },
  });
};

export const toastError = (message = "Something went wrong!") => {
  return toast.error(message, {
    duration: 2000,
    style: {
      background: "radial-gradient(circle at top, #1F7A3E, #C8A97E, #3FAF6B)",
      color: "#fff",
    },
    iconTheme: {
      primary: "#fff",
      secondary: "#3FAF6B",
    },
  });
};

export const toastWarning = (message = "Something went wrong!") => {
  return toast.success(message, {
    duration: 2000,
    style: {
      background: "radial-gradient(circle at top, #1F7A3E, #C8A97E, #3FAF6B)",
      color: "#fff",
    },
    iconTheme: {
      primary: "#fff",
      secondary: "#3FAF6B",
    },
  });
};

export const toastInfo = (message = "Info") => {
  return toast.success(message, {
    duration: 2000,
    style: {
      background: "radial-gradient(circle at top, #1F7A3E, #C8A97E, #3FAF6B)",
      color: "#fff",
    },
    iconTheme: {
      primary: "#fff",
      secondary: "#3FAF6B",
    },
  });
};

const handleApiError = (error) => {
  console.error("API Error:", error);

  let message = "Server Error";

  if (!navigator.onLine) {
    message = "No internet connection";
  } else if (error?.response?.data?.message) {
    message = error.response.data.message;
  } else if (typeof error?.response?.data === "string") {
    message = error.response.data;
  } else if (error?.message) {
    message = error.message;
  }
  toastError(message);
  throw new Error(message);
};
